import { useLazyQuery } from '@apollo/client';
import { GetQuestionnaire } from 'pages/CarePlans/Builder/QuestionnaireCreation/gql/getQuestionnaire';

const useGetQuestionnaireByIdLazy = () => {
  const [loadQuestionnaire, { loading, error, data }] = useLazyQuery(
    GetQuestionnaire,
    {
      fetchPolicy: 'no-cache',
    }
  );

  if (data) {
    return {
      questionnaire: data?.questionnaire?.questionnaireById,
      loading,
      loadQuestionnaire,
      error,
    };
  } else {
    return {
      questionnaire: {},
      loading,
      loadQuestionnaire,
      error,
    };
  }
};

export default useGetQuestionnaireByIdLazy;
